import React from 'react';
import { SelectionCell } from '@/components/ui';
import type { Neighborhood } from '@repo/api';
import { cn } from '@/lib/cn';

export type ExtendedNeighborhood = Neighborhood & { parentId?: string | null };

export interface NeighborhoodItemProps {
  neighborhood: ExtendedNeighborhood;
  isSelected: boolean;
  onToggle: () => void;
  className?: string;
  isNested?: boolean;
  leadingIcon?: React.ReactNode;
}

export const NeighborhoodItem = React.memo(function NeighborhoodItem({
  neighborhood,
  isSelected,
  onToggle,
  className,
  isNested = false,
  leadingIcon,
}: NeighborhoodItemProps) {
  return (
    <SelectionCell
      selected={isSelected}
      leadingIcon={leadingIcon}
      title={neighborhood.name}
      offset={isNested}
      onToggle={onToggle}
      className={cn('w-full cursor-pointer', className)}
    />
  );
});

export default NeighborhoodItem;
